import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function ReportsAggregatorNameModalForm({
  setSpinner,
  close,
  createReport,
  aggregators,
  getAggregators,
}) {
  const [aggregatorId, setAggregatorId] = useState('');

  useEffect(() => {
    (async () => {
      setSpinner(true);
      await getAggregators();
      setSpinner(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () =>
    createReport({ aggregatorId: aggregatorId ? Number(aggregatorId) : null });

  return (
    <>
      <Row className="align-items-center">
        <Col md={4} className="bo-same-line">
          <Form.Label>Aggregator:</Form.Label>
        </Col>
        <Col md={8} className="bo-same-line">
          <Form.Select
            className="bo-filter bo-w-250"
            value={aggregatorId}
            onChange={e => setAggregatorId(e.target.value)}
          >
            <option value="">All Standard Aggregators</option>
            {aggregators.map(agg => (
              <option key={agg.id} value={agg.id}>
                {agg.name}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="mt-auto">
        <Col className="d-flex justify-content-center gap-3">
          <Button className="bo-button" onClick={handleCreate}>
            Create
          </Button>
          <Button className="bo-button" onClick={close}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default ReportsAggregatorNameModalForm;
